export default class extends HTMLElement {
  constructor() {
    super();
    console.log('Init DSBReader');
    this.path = [];
  }

  get service() {
      return this.getAttribute('service');
  }

  set service(newValue){
      this.setAttribute('service', newValue);
  }

  get collection_id() {
      return this.getAttribute('collection_id');
  }

  set collection_id(newValue){

      if(!Array.isArray(newValue))
      {
        newValue = newValue.split(',');
      }
      let collection_id = 0;
      for (let i = 0; i < newValue.length; i++) {
        if(i == 0)
        {
          collection_id = newValue[i];
        }
        else
        {
          if(newValue[i])
          {
            this.path.push(newValue[i]);
          }
        }
      }
      this.setAttribute('collection_id', collection_id);
  }

  get type() {
      return this.getAttribute('type');
  }

  set type(newValue){
      this.setAttribute('type', newValue);
  }

  async getCPDSchemes()
  {
    let _json = await this.dsbClient.content.get(this.service,"?type[in][]=cpd_scheme");
    this.cpd_schemes = {};
    if(_json.state)
    {
      let data = {};
      let _cpd_schemes = _json.data;
      if(_cpd_schemes.length > 0)
      {
        for(var schemes in _cpd_schemes)
        {
          this.cpd_schemes[_cpd_schemes[schemes].id] =_cpd_schemes[schemes];
        }
      }
    }
    else
    {
      throw "No data found!";
    }
  }


  setDSBClient(dsbClient){
      this.dsbClient=dsbClient;
  }

  reset()
  {
    if(this.data)
    {
     delete this.data;
    }
  }

  setData(_data)
  {
      let data = {};
      this.data = {};
      if(_data[0])
      {
        data = _data[0];
      }

      if('document' in data)
      {
        if('sections' in data.document)
        {
          this.data.sections = data.document.sections;
        }
        else if('parts' in data.document)
        {
          this.data.sections = data.document.parts;
        }

        if('metadata' in data.document)
        {
          if('cpd_points' in data.document.metadata)
          {
            this.data.schemes = data.document.metadata.cpd_points;
          }
        }

        if('scheme' in data.document)
        {
          this.data.schemes = data.document.scheme;
        }

        if('author' in data.document)
        {
          this.data.author = data.document.author;

          if('type' in this.data.author)
          {
            if(this.data.author.type == 'advert')
            {
              this.data.advertiser_logo = this.dsbClient.content.applyFilter(`formatData_lookup`, [ `author_advertiser_logo`, this.data.author.id ] );
            }
          }
        }

        this.data.content = {};

        if('id' in data.document)
        {
          this.data.content.id = data.document.id;
        }
        if('title' in data.document)
        {
          this.data.content.title = data.document.title;
        }
        if('images' in data.document)
        {
          if('large-card' in data.document.images)
          {
            this.data.content.image = data.document.images['large-card'];
          }
        }
        if('content' in data.document)
        {
          if('rendered' in data.document.content)
          {
            this.data.content.body = data.document.content.rendered;
          }
        }
        if('post_widgets' in data.document)
        {
          this.data.content.post_widgets = data.document.post_widgets;
        }

        this.data.taxonomies = {};

        if('taxonomies' in data.document)
        {
          this.data.taxonomies = data.document.taxonomies;
        }
      }
  }

  async _getUserDataByStatus(status,field=false, all=true)
  {
    let current_user_data = await this.dsbClient.user.get('cpd', '?type=collection&link_type='+this.service+'&status='+status+'&name[sort]=desc'+(all==false?'&_[limit]=1':''),(all==false?true:false));

    if(typeof current_user_data === 'object' && current_user_data !== null)
    {
      if(field)
      {
        if(field in current_user_data)
        {
          return current_user_data[field];
        }
      }
      else
      {
        return current_user_data;
      }
    }
    return false;
  }

  async _getUserData(path, field=false, all=false)
  {
    let current_user_data = await this.dsbClient.user.get('cpd', '?type=collection&link_type='+this.service+'&link_value='+path+'&iteration[sort]=desc'+(all==false?'&_[limit]=1':''),(all==false?true:false));

    if(typeof current_user_data === 'object' && current_user_data !== null)
    {
      if(field)
      {
        if(field in current_user_data)
        {
          return current_user_data[field];
        }
      }
      else
      {
        return current_user_data;
      }
    }
    return false;
  }

  async _getUserDataPointsHistory(path)
  {
    let current_user_data = await this._getUserData(path,false,true);
    if(typeof current_user_data === 'object' && current_user_data !== null)
    {
      if(!Array.isArray(current_user_data))
      {
        let _current_user_data = [];
        _current_user_data.push(current_user_data);
        current_user_data = _current_user_data;
      }

      let return_data = {};

      for(let i = 0; i<current_user_data.length; i++)
      {
        if('points' in current_user_data[i])
        {
          for(let aScheme in current_user_data[i].points)
          {
            if(!(aScheme in return_data))
            {
              return_data[aScheme] = {};
              return_data[aScheme]['history'] = [];
              return_data[aScheme]['codes'] = [];
            }
            return_data[aScheme]['history'].push(current_user_data[i].points[aScheme]);

            if(`code` in current_user_data[i].points[aScheme])
            {
              return_data[aScheme]['codes'].push(current_user_data[i].points[aScheme].code);
            }
          }
        }
      }
      return return_data;
    }
    return false;
  }

  async _getUserSchemeMembershipIds(path, field=false, all=false)
  {
    let current_user_data = await this.dsbClient.user.get('data', '?type=profile&status=published&profile&name=scheme_member_ids&limit=1',true);
    if(typeof current_user_data === 'object' && current_user_data !== null && 'data' in current_user_data)
    {
      return current_user_data.data;
    }
    return {};
  }

  connectedCallback()
  {
    return this._render();
  }

  throwError(error)
  {
    window.dispatchEvent(new CustomEvent('dsb-app-throwError', {message: error}));
    return;
  }

  _createUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  async _render()
  {
    let _this = this;
    let sections = {};
    let content = {};
    let base_update = {};
    let _json = {};
    let modal_mode = this.dsbClient.user.env.isViewport([`small`,`xsmall`]);

    var resume_aside = document.createElement("aside");
    resume_aside.id="resume_aside-collection";
    resume_aside.setAttribute('class','right');

    window.dispatchEvent(new CustomEvent('dsb-pwa-append_tray', {detail: {iam: _this, onclick: async function(){

      let panel = document.querySelector('#resume_aside-collection');
      panel.innerHTML = `
         <maa-spinner></maa-spinner>
      `;
      panel.classList.toggle('show');
      if(!(panel.classList.contains('show')))
      {
        panel.innerHTML = ``;
      }

      try
      {
        let userdata = await _this._getUserDataByStatus('active');
        if(typeof userdata === 'object' && userdata !== null)
        {
          // Task Panel
          var nav_task_panel = document.createElement("dsb-tasks");
          nav_task_panel.init();
          nav_task_panel.setDSBClient(_this.dsbClient);
          nav_task_panel.setAttribute('data-target_type','window');
          nav_task_panel.setAttribute('class','active_collection');
          nav_task_panel.header = "Active collections";

          let hash = location.hash;
          if(hash.indexOf("#/") > -1)
          {
            hash = hash.substring((hash.indexOf("#/")+2),hash.length);
          }
          hash = hash.split("/");
          let current_id = hash.pop();
          hash = hash.join('/');

          for(let active_collection in userdata)
          {
            if('name' in userdata[active_collection])
            {
              var task = {};
              task.name = userdata[active_collection].name;
              task.task = true;
              task.type = 'task_notick';
              task.modal_mode = false;

              if(current_id == userdata[active_collection].link_value)
              {
                task.active = true;
              }
              task.uid = 'active_collection_'+userdata[active_collection].id;
              task.hash_url = hash + '/'+userdata[active_collection].link_value;
              task.progress = 0;
              if('progress' in userdata[active_collection])
              {
                let current_user_progress_total = 0;
                let current_user_progress_complete = 0;
                for(let part in userdata[active_collection].progress)
                {
                  current_user_progress_total++;
                  if(userdata[active_collection].progress[part])
                  {
                    current_user_progress_complete++;
                  }
                }

                if(current_user_progress_total != 0)
                {
                  task.progress = Math.floor((current_user_progress_complete/current_user_progress_total)*100);
                }

                if(task.progress == 100)
                {
                  task.progress = 99;
                }
              }

              if(('update_date' in userdata[active_collection]) && userdata[active_collection].update_date!=null)
              {
                task.last_update = userdata[active_collection].update_date;
              }
              else if(('created_date' in userdata[active_collection]) && userdata[active_collection].created_date!=null)
              {
                task.last_update = userdata[active_collection].created_date;
              }

              nav_task_panel.addTask(task);
            }
          }
          panel.innerHTML = ``;
          nav_task_panel.addHook('on_render_complete',function(){
            nav_task_panel.refreshActive();
          });
          panel.append(nav_task_panel);
        }
      }
      catch(ex)
      {
        console.error(ex);
        panel.innerHTML = `
          <div style="overflow-x: auto;min-height:200px;margin-top:30px;">
              <article class="error-500" role="article">
                <p style="font-size: 2em;">Sorry an error has occured.</p>
                <p>Please try again later.</p>
              </article>
          </div>`;
      }


    },icon: 'icon-view_list',
      init_append:resume_aside,
      overlay:true
    }}));

    try
    {

      if (typeof this.data == 'undefined')
      {
        let _json = await this.dsbClient.content.get(this.service,this.collection_id);
        if(_json.state)
        {
          await this.setData(_json.data);
        }
        else
        {
          throw "No data found!";
        }
      }

      var workspaces_modal_panel = document.createElement("dsb-workspace");
      workspaces_modal_panel.init();
      workspaces_modal_panel.setDSBClient(this.dsbClient);

      if('advertiser_logo' in this.data)
      {
        if(this.data.advertiser_logo.length > 0)
        {
          this.classList.add('advertiser');
          this.classList.add('advertiser-category-col');
          workspaces_modal_panel.classList.add('advertiser');
          workspaces_modal_panel.classList.add('advertiser-category-col');
        }
      }
      else if('taxonomies' in this.data)
      {
        if('category' in this.data.taxonomies)
        {
          if('primary_id' in this.data.taxonomies.category)
          {
            this.data.primary_cat = this.dsbClient.content.applyFilter(`formatData_lookup`, [ `primary_cat_slug`, this.data.taxonomies.category.primary_id ] );
            this.classList.add(this.data.primary_cat);
            this.classList.add(this.data.primary_cat+'-category-col');
            workspaces_modal_panel.classList.add(this.data.primary_cat);
            workspaces_modal_panel.classList.add(this.data.primary_cat+'-category-col');
          }
        }
      }

      var aside_panel = document.createElement("aside");
      var nav_panel = document.createElement("nav");

      // Workspace panel
      var workspaces_panel = document.createElement("dsb-workspace");
      workspaces_panel.init();
      workspaces_panel.setDSBClient(this.dsbClient);

      // Task Panel
      var nav_task_panel = document.createElement("dsb-tasks");
      nav_task_panel.init();
      nav_task_panel.setDSBClient(this.dsbClient);


      // Get user progress
      let current_user_progress = {};
      let current_user_progress_complete = 0;

      let function__refresh_current_user_progress = async function(){
        current_user_progress = await _this._getUserData(_this.data.content.id, 'progress');
        current_user_progress_complete = 0;
        if(typeof current_user_progress === 'object' && current_user_progress !== null)
        {
          let current_user_progress_total = 0;
          for(let asection in current_user_progress)
          {
            current_user_progress_total++;
            if(current_user_progress[asection])
            {
              current_user_progress_complete++;
            }
          }
          if(current_user_progress_total != 0)
          {
            current_user_progress_complete = Math.floor((current_user_progress_complete/current_user_progress_total)*100);
          }
        }
      }

      await function__refresh_current_user_progress();

      let current_user_data_points_history = await this._getUserDataPointsHistory(_this.data.content.id);
      console.info('dsb-reader: data_points_history',current_user_data_points_history);

      let current_user_data_scheme_membership_ids = await this._getUserSchemeMembershipIds();
      console.info('dsb-reader: scheme_member_ids',current_user_data_scheme_membership_ids);

      console.info('dsb-reader: schemes',this.data.schemes);


      // Get schemes
      var current_schemes = {};
      if('schemes' in this.data)
      {
        await this.getCPDSchemes();
        for(let i = 0; i<this.data.schemes.length; i++)
        {
            if( 'scheme_id' in this.data.schemes[i])
            {
              let this_scheme_id = this.data.schemes[i].scheme_id;
              current_schemes[this_scheme_id]={};
              current_schemes[this_scheme_id].pattern = '';
              current_schemes[this_scheme_id].pattern_message = '';
              let lookup_Scheme = this.dsbClient.content.applyFilter(`formatData_lookup`, [ `cpd_scheme`, this_scheme_id ] );
              if(typeof lookup_Scheme === 'object' && lookup_Scheme !== null && 'name' in lookup_Scheme)
              {
                current_schemes[this_scheme_id].title=lookup_Scheme.name;
                if('settings' in lookup_Scheme && typeof lookup_Scheme.settings === 'object' && lookup_Scheme.settings !== null)
                {
                  if('codevalidationpattern' in lookup_Scheme.settings && lookup_Scheme.settings.codevalidationpattern.length > 0)
                  {
                    current_schemes[this_scheme_id].pattern=lookup_Scheme.settings.codevalidationpattern;
                  }
                  if('codevalidationmessage' in lookup_Scheme.settings && lookup_Scheme.settings.codevalidationmessage.length > 0)
                  {
                    current_schemes[this_scheme_id].pattern_message=lookup_Scheme.settings.codevalidationmessage;
                  }
                  if('color' in lookup_Scheme.settings && lookup_Scheme.settings.color.length > 0)
                  {
                    current_schemes[this_scheme_id].color=lookup_Scheme.settings.color;
                  }
                  if('color_text' in lookup_Scheme.settings && lookup_Scheme.settings.color_text.length > 0)
                  {
                    current_schemes[this_scheme_id].color_text=lookup_Scheme.settings.color_text;
                  }
                }
              }
              else
              {
                current_schemes[this_scheme_id].title=this.dsbClient.content.applyFilter(`formatData_lookup`, [ `cpd_scheme_name`, this_scheme_id ] );
              }

              current_schemes[this_scheme_id].completed = false;

              if( 'points' in this.data.schemes[i])
              {
                current_schemes[this_scheme_id].points=this.data.schemes[i].points;
              }
              else
              {
                current_schemes[this_scheme_id].points=0;
              }

              if( 'codes' in this.data.schemes[i])
              {
                current_schemes[this_scheme_id].codes=this.data.schemes[i].codes;
                if(this_scheme_id in current_user_data_points_history)
                {
                  if('codes' in current_user_data_points_history[this_scheme_id])
                  {
                    for(let i = 0; i < current_user_data_points_history[this_scheme_id].codes.length; i++)
                    {
                      for(let ii = 0; ii <  current_schemes[this_scheme_id].codes.length; ii++)
                      {
                        if(current_schemes[this_scheme_id].codes[ii].indexOf(current_user_data_points_history[this_scheme_id].codes[i]) != -1)
                        {
                          current_schemes[this_scheme_id].completed = true;
                          //i = current_user_data_points_history[this_scheme_id].codes.length;
                          break;
                        }
                      }
                    }
                  }
                }
              }
              else
              {
                current_schemes[this_scheme_id].codes=[];
              }
            }
        }
      }

      console.info('dsb-reader: current_schemes',current_schemes);

      var hook__route_task_click = async function(target, task)
      {
        target.reset();
        let content = document.createElement("dsb-post");
        content.setDSBClient(target.dsbClient);
        content.setAttribute(`settings`, JSON.stringify({'clean_body':'on','pulldown_refresh':'off'}));


        if( `post_data` in task)
        {
          content.setPostData(task.post_data);
        }
        else
        {
          content.setAttribute('post_id', task.target_id);
        }
        content.setAttribute('service', task.target);

        let tabs = {};

        if( `tabs` in task)
        {
          for(let i = 0; i < task.tabs.length; i++)
          {
            tabs[task.tabs[i].name]={'name':task.tabs[i].name,'content':task.tabs[i].content, 'status': false};
          }
        }

        var footer = {};

        if('back_id' in task)
        {
          let back_button = document.createElement("button");
          back_button.setAttribute('task-id',task.back_id);
          back_button.setAttribute('class','grey');
          back_button.innerHTML = "Back";
          back_button.setAttribute('data-open_task',false);
          back_button.setAttribute('data-open_task_uid',task.uid);
          if('type' in task)
          {
            if(task.type == 'read')
            {
              back_button.setAttribute('data-open_task',task.task_id);
              back_button.innerHTML = "Back (Mark as unread)";
            }
          }
          back_button.onclick = async function(){
            if(!_this.dsbClient.user.is_offline())
            {
              let open_task = this.getAttribute('data-open_task');
              let open_task_uid = this.getAttribute('data-open_task_uid');
              if(open_task != 'false' && open_task_uid)
              {
                let cpd = await _this._getUserData(_this.data.content.id);
                if(cpd)
                {
                  if(typeof cpd.data === 'object' && cpd.data !== null)
                  {
                  // Nice :)
                  }
                  else
                  {
                    cpd.data = {};
                  }
                  cpd.type = 'collection';
                  cpd.link_type = _this.service;
                  cpd.link_value = _this.data.content.id;
                  cpd.name = _this.data.content.title;
                  cpd.data['part_'+open_task_uid]=false;
                  let returned = await _this.dsbClient.user.post('cpd', cpd);
                  if('result' in returned)
                  {
                    if(returned.result)
                    {
                      nav_task_panel.setDone(open_task, false);
                    }
                  }
                }
              }
            }

            document.getElementById(this.getAttribute('task-id')).dispatchEvent(new MouseEvent("click", {
                  "view": window,
                  "bubbles": true,
                  "cancelable": false
            }));
          };
          footer.back = back_button;
        }

        if('next_id' in task)
        {
          let next_button = document.createElement("button");
          next_button.setAttribute('task-id',task.next_id);
          next_button.setAttribute('data-complete_task',false);
          next_button.setAttribute('data-complete_task_uid',task.uid);
          if('type' in task)
          {
            if(task.type == 'read')
            {
              next_button.setAttribute('data-complete_task',task.task_id);
            }
          }
          next_button.setAttribute('name','next');
          next_button.onclick = async function(){
            if(!_this.dsbClient.user.is_offline())
            {
              let complete_task = this.getAttribute('data-complete_task');
              let complete_task_uid = this.getAttribute('data-complete_task_uid');
              if(complete_task != 'false' && complete_task_uid)
              {
                let cpd = await _this._getUserData(_this.data.content.id);
                if(cpd)
                {
                  if(typeof cpd.data === 'object' && cpd.data !== null)
                  {
                  // Nice :)
                  }
                  else
                  {
                    cpd.data = {};
                  }
                  cpd.type = 'collection';
                  cpd.link_type = _this.service;
                  cpd.link_value = _this.data.content.id;
                  cpd.name = _this.data.content.title;
                  cpd.data['part_'+complete_task_uid]=true;
                  let returned = await _this.dsbClient.user.post('cpd', cpd);
                  if('result' in returned)
                  {
                    if(returned.result)
                    {
                      nav_task_panel.setDone(complete_task);
                    }
                  }
                }
              }
            }
            document.getElementById(this.getAttribute('task-id')).dispatchEvent(new MouseEvent("click", {
                  "view": window,
                  "bubbles": true,
                  "cancelable": false
            }));
          };
          if('back_id' in task)
          {
            next_button.innerHTML = "Next";
            if(task.type == 'read')
            {
              next_button.innerHTML = "Next (Mark as read)";
            }
            footer.next = next_button;
          }
          else
          {
            next_button.innerHTML = "Start";
            await function__refresh_current_user_progress();

            //History Tab
            let current_user_data_points_history = await _this._getUserData(_this.data.content.id,false,true);
            if(current_user_data_points_history)
            {
              let history_panel = document.createElement("section");
              history_panel.setAttribute(`class`, `message`);
              let history_panel_ol = document.createElement("ol");
              for(let i = 0; i < current_user_data_points_history.length; i++)
              {
                if(current_user_data_points_history[i].status == 'complete')
                {
                  let _li = document.createElement("li");
                  _li.setAttribute(`class`,`icon-job-done-outline`);
                  let entry = '';
                  if('points' in current_user_data_points_history[i])
                  {
                    for(let mySchemePoint in current_user_data_points_history[i].points)
                    {
                      if(mySchemePoint in current_schemes)
                      {
                        entry+=current_user_data_points_history[i].points[mySchemePoint].points+" points from "+current_schemes[mySchemePoint].title+" ("+current_user_data_points_history[i].points[mySchemePoint].code+") using the Member ID "+current_user_data_points_history[i].points[mySchemePoint].member_id;
                      }
                    }
                  }
                  _li.innerHTML = `Completed `+_this.dsbClient.user.format_date(current_user_data_points_history[i].update_date)+'<br/>'+entry;
                  history_panel_ol.append(_li);
                }
              }

              if(history_panel_ol.childNodes.length > 0)
              {
                history_panel.append(history_panel_ol);
                tabs['History'] = {'name':'History','content':history_panel, 'status': false};
              }
            }

            if(current_user_progress_complete > 0)
            {
              let detail_panel = document.createElement("section");
              let message_panel = document.createElement("section");
              message_panel.setAttribute(`class`, `message`);
              let message_ol = document.createElement("ol");
              message_panel.append(message_ol);
              let aMessage = document.createElement("li");
              if(current_user_progress_complete == 100)
              {
                try
                {
                  let current_user_data = await _this._getUserData(_this.data.content.id,false,false);
                  aMessage.setAttribute(`class`,`icon-check-circ done`);
                  if('status' in current_user_data)
                  {
                    switch(current_user_data.status)
                    {
                      case "complete":
                          aMessage.innerHTML=`Well done. You completed this collection on the `+_this.dsbClient.user.format_date(current_user_data.update_date);

                          let retake_input = document.createElement("input");
                          retake_input.type = 'button';
                          retake_input.value = 'Re-take';
                          retake_input.setAttribute('task-id',task.next_id);
                          retake_input.setAttribute('class','grey');
                          retake_input.onclick = async function(){
                            let returned = await _this.dsbClient.user.post('cpd?action=iteration', {'type': current_user_data.type, 'link_type': current_user_data.link_type, 'link_value': current_user_data.link_value, 'name': current_user_data.name, 'iteration':current_user_data.iteration});
                            if(returned)
                            {
                              window.location.reload(true);
                              return;
                            }
                            else
                            {
                              aMessage.setAttribute(`class`,`icon-error`);
                              aMessage.innerHTML=`Sorry, an error seems to have occured.<br/>Please try again later.`;
                              console.error(`dsb-reader::hook__route_task_click - reset error`,returned);
                            }
                          };

                          if(_this.dsbClient.user.is_offline())
                          {
                            retake_input.disabled = true;
                          }

                          if('part_overview' in current_user_data.data)
                          {
                            let points_summary = '';
                            let retake_summary = [];
                            let count_points = 0;
                            if('points' in current_user_data)
                            {
                              for(let current_schemes_id in current_schemes)
                              {
                                if(typeof current_user_data.points === 'object' && current_user_data.points !== null)
                                {
                                  if(current_schemes_id in current_user_data.points)
                                  {
                                      count_points++;
                                      points_summary+="<li>"+current_user_data.points[current_schemes_id].points+" points from "+current_schemes[current_schemes_id].title+" ("+current_user_data.points[current_schemes_id].code+") using the Member ID "+current_user_data.points[current_schemes_id].member_id+"</li>";
                                      if(!current_schemes[current_schemes_id].completed)
                                      {
                                        retake_summary.push(current_schemes[current_schemes_id].title+" have updated their code");
                                      }
                                  }
                                  else
                                  {
                                    retake_summary.push(current_schemes[current_schemes_id].title+" have not been notified (no Member ID provided)");
                                  }
                                }
                                else
                                {
                                  retake_summary.push(current_schemes[current_schemes_id].title+" have not been notified (no Member ID provided)");
                                }
                              }

                              if(count_points == 0)
                              {
                                detail_panel.append(retake_input);
                              }
                            }

                            if(points_summary.length == 0)
                            {
                              //points_summary = `You gained 0 points as no schemes are attached to this collection.`;
                            }
                            else
                            {
                              let result_p = document.createElement("p");
                              points_summary="We have notified the following schemes: <br/><ul>"+points_summary+"</ul>";
                              result_p.innerHTML = points_summary;
                              detail_panel.append(result_p);
                            }

                            if(retake_summary.length > 0)
                            {
                              let retake_panel = document.createElement("section");
                              let retake_message = document.createElement("section");
                              retake_message.setAttribute(`class`, `message`);
                              //retake_panel.setAttribute(`style`,'margin-top:10px;border-top:1px solid;');
                              let retake_panel_ol = document.createElement("ol");

                              for(let i = 0; i < retake_summary.length; i++)
                              {
                                let _li = document.createElement("li");
                                _li.setAttribute(`class`,`icon-warning done`);
                                _li.innerHTML = retake_summary[i];
                                retake_panel_ol.append(_li);
                              }


                              let retake_p1 = document.createElement("p");
                              retake_p1.innerHTML = "You have not claimed points from all schemes.";
                              let retake_p2 = document.createElement("p");
                              retake_p2.innerHTML = "To gain points from unclaimed schemes please retake the collection by clicking the button below";

                              retake_panel.append(retake_p1);
                              retake_message.append(retake_panel_ol);
                              retake_panel.append(retake_message);
                              retake_panel.append(retake_p2);
                              retake_panel.append(retake_input);
                              detail_panel.append(retake_panel);
                            }

                          }
                          else
                          {
                            throw `Sorry an unexpected error has occured (missing overview). Please try again later.`;
                          }
                          break;
                      default:
                          if(`Quiz` in tabs)
                          {
                            aMessage.innerHTML=`Well done. You have completed this collection.<br/><small>Now please complete the form below and click the "Submit to schemes" button</small>`;
                            let preamble = document.createElement("p");
                            preamble.innerHTML = `Please check or enter your Scheme member ID below for submission to CPD scheme.<br/><small>If no member ID is added your completion will not be registered with the CPD scheme.</small>`;
                            detail_panel.append(preamble);
                            tabs[`Quiz`].content.setAttribute(`submit_button_name`,`Submit to schemes`)
                            tabs[`Quiz`].content.setAttribute(`data-record_data`,`scheme_member_ids`)
                            let form = document.createElement("section");
                            form.setAttribute(`class`, `form__cpd_schemes`);
                            form.append(tabs[`Quiz`].content);
                            detail_panel.append(form);
                          }
                          else
                          {
                            throw `Sorry, and unexpected error has occured (missing CPD scheme form). Please try again later.`;
                          }
                          break;
                    }
                  }
                  else
                  {
                    throw `Sorry, your current status on this collection appears to be unknown.<br/><small>Please re-submit the last section or report this issue.</small>`;
                  }
                }
                catch(ex)
                {
                  aMessage.innerHTML = ex;
                  aMessage.setAttribute(`class`,`icon-error`);
                  console.error(ex);
                }

                // Tidy
                if(`Quiz` in tabs)
                {
                  delete tabs[`Quiz`];
                }

                message_ol.append(aMessage);
                content.appendContent(message_panel);
                if(detail_panel.childNodes.length > 0)
                {
                  content.appendContent(detail_panel);
                }
              }
              else
              {
                aMessage.setAttribute(`class`,`icon-info`);
                aMessage.innerHTML=`You are `+current_user_progress_complete+`% through this collection.`;
                next_button.innerHTML = "Resume";
                next_button.setAttribute('task-id',nav_task_panel.getNextNotDoneTaskId());
                content.addFooter(next_button);
                message_ol.append(aMessage);
                content.appendContent(message_panel);
                delete tabs[`Quiz`];
              }
            }
            else
            {
              delete tabs[`Quiz`];
              content.addFooter(next_button);
            }
          }
        }

        target.setTab('Document', content, true, false);

        for(let i in tabs)
        {
          if(tabs[i].name == 'Quiz')
          {
            tabs[i].content.resetFooter();
            if('next' in footer)
            {
              tabs[i].content.addFooter(footer.next);
            }

            tabs[i].content.setAttribute(`data-caller_id`,task.task_id);

            let next_button = document.createElement("button");
            next_button.innerHTML = "Next";
            next_button.onclick = function(){
              target.switchTab('Quiz');
            };

            footer.next = next_button;
          }
          target.setTab(tabs[i].name, tabs[i].content, false, false);
        }

        for(var element in footer)
        {
          content.addFooter(footer[element]);
        }

        target.render();

      };

      let target_modal_id = 'reader_'+this._createUUID();
      nav_task_panel.addHook('route', hook__route_task_click);
      nav_task_panel.setAttribute(`data-target_modal`, 'dsb-add_modal__'+target_modal_id);
      nav_task_panel.setAttribute(`data-target_panel`, workspaces_panel.getAttribute('id'));
      nav_task_panel.setAttribute(`data-target_modal_panel`, workspaces_modal_panel.getAttribute('id'));

      window.dispatchEvent(new CustomEvent('dsb-pwa-add_modal', {detail: {"id":target_modal_id,"content":workspaces_modal_panel}}));

      /**
      let modal = document.querySelector('dsb-modal > dsb-modal-workspace');
      modal.innerHTML = ``;
      modal.append(workspaces_modal_panel);
      */

      var collection_card = document.createElement("div");
      collection_card.setAttribute(`class`, `category-bg-color`);
      collection_card.innerHTML = ``;
      var collection_card_html = document.createElement("span");
      collection_card_html.classList.add('detail_panel');
      collection_card_html.innerHTML = ``;

      //base_update.appname = 'Collection';

      var overview_task = {};
      overview_task.name = 'Overview';
      overview_task.active = false;
      overview_task.type = 'overview';
      overview_task.uid = `overview`;
      overview_task.modal_mode = false;
      if(modal_mode)
      {
        overview_task.hidden = true;
      }
      overview_task.questions = [];
      for(var scheme_id in current_schemes)
      {
        let aquestion = {
          'uid' :'scheme_'+scheme_id,
          'question':current_schemes[scheme_id].title,
          'pattern':current_schemes[scheme_id].pattern,
          'pattern_message':current_schemes[scheme_id].pattern_message,
          'type': 'text'
        };

        if(typeof current_user_data_scheme_membership_ids === 'object' && current_user_data_scheme_membership_ids !== null)
        {
          if(scheme_id in current_user_data_scheme_membership_ids)
          {
            aquestion.value = current_user_data_scheme_membership_ids[scheme_id];
          }
        }

        overview_task.questions.push(aquestion);
      }

      if('content' in this.data)
      {
        if('id' in this.data.content)
        {
          overview_task.target_id = this.data.content.id;
          overview_task.target = this.service;
        }

        if('body' in this.data.content)
        {
          overview_task.post_data = {};
          overview_task.post_data.title = 'Overview';
          overview_task.post_data.body = this.data.content.body;
          overview_task.post_data.document = {};
          overview_task.post_data.document.title = 'Overview';
          overview_task.post_data.document.content = {};
          overview_task.post_data.document.content.rendered = this.data.content.body;
        }

        if('title' in this.data.content)
        {
          //base_update.title = this.data.content.title;
           let h2 = document.createElement("h2");
           h2.innerHTML = this.data.content.title;
           collection_card_html.append(h2);
        }

        if('advertiser_logo' in this.data)
        {
           let advertiser_logo_panel = document.createElement("span");
           advertiser_logo_panel.classList.add('advertiser_panel');
           let advertiser_logo_title = document.createElement("h3");
           advertiser_logo_title.innerHTML = `Advertiser collection`;
           let advertiser_logo = document.createElement("div");
           advertiser_logo.setAttribute('style','background-image:url('+this.data.advertiser_logo+')');
           advertiser_logo.classList.add('circle-image');
           advertiser_logo_panel.append(advertiser_logo_title);
           advertiser_logo_panel.append(advertiser_logo);
           collection_card.append(advertiser_logo_panel);
        }


        if('image' in this.data.content)
        {
          //collection_card.setAttribute(`src`,this.data.content.image);
        }

        if('taxonomies' in this.data)
        {
          if('category' in this.data.taxonomies)
          {
            if('primary_id' in this.data.taxonomies.category)
            {
              this.classList.add(this.data.taxonomies.category.primary_id);
            }
          }
        }
      }

      // Setup schemes
      if('schemes' in this.data)
      {
        var cpd_points = document.createElement("ul");
        cpd_points.setAttribute(`class`,'cpd_points');
        let count_schemes = 0;
        for(var scheme_id in current_schemes)
        {
          count_schemes++;
          let _link = document.createElement("li");
          _link.innerHTML = `<span>`+current_schemes[scheme_id].points+`</span><span>`+current_schemes[scheme_id].title+`</span>`;
          cpd_points.append(_link);
        }
        if(count_schemes > 0)
        {
          collection_card_html.append(cpd_points);
        }
        else
        {
          cpd_points=null;
        }
      }
      collection_card.append(collection_card_html);

      if(Array.isArray(this.path))
      {
        if(this.path.length==0)
        {
          overview_task.active = true;
        }
      }

      window.dispatchEvent(new CustomEvent('dsb-pwa-base_update', {detail: base_update}));

      // Check data for sections and root subsections
      if('sections' in this.data)
      {
        if(this.data.sections.length == 1)
        {
          this.data.sections = this.data.sections[0].parts;
          this.data.sections.unshift(overview_task);
        }
        else
        {
          nav_task_panel.addTask(overview_task);
        }
      }
      else
      {
        throw "No sections found!";
      }

      var set_tabs = async function(item, path)
      {
        item.tabs = [];
        if(`questions` in item)
        {
          if((`type` in item) && item.type == 'overview')
          {
            // Leave as overview
          }
          else
          {
            item.type = 'quiz';
            if(item.questions.length == 0)
            {
                item.type = 'read';
            }
          }


          if(current_user_progress)
          {
            if(`part_`+item.uid in current_user_progress)
            {
              if(current_user_progress[`part_`+item.uid] == true)
              {
                item.done=true;
              }
            }
          }

          if(item.questions.length > 0)
          {
            let quiz = document.createElement("dsb-quiz");
            quiz.setDSBClient(_this.dsbClient);

            if(item.type == 'quiz')
            {
               quiz.addSetting('show_count',true);
               quiz.addSetting('show_incorrect_ans',true);
            }

            quiz.init();
            quiz.setAttribute('source_id', path);
            quiz.setAttribute('source_type', _this.service);
            quiz.setAttribute('name', _this.data.content.title);

            quiz.addHook('on_complete',async function(controller, data=false){
              let overview_task = '0';
              try
              {
                if(controller.hasAttribute('data-caller_id'))
                {
                  let current_task = controller.getAttribute('data-caller_id').split("-");
                  if(current_task.length == 2)
                  {
                    overview_task=current_task[0]+'-0';
                  }
                }

                if(controller.hasAttribute('data-record_data'))
                {
                  let record_data = controller.getAttribute('data-record_data');

                  switch(record_data)
                  {
                    case "scheme_member_ids":
                        if('part_overview' in data)
                        {
                          for(let scheme_key in data.part_overview)
                          {
                            let scheme_id = scheme_key.split('question_scheme_');
                            if(scheme_id.length == 2)
                            {
                              scheme_id = scheme_id[1];
                            }
                            current_user_data_scheme_membership_ids[scheme_id] = data.part_overview[scheme_key];
                          }
                        }

                        let returned = await _this.dsbClient.user.post('data', {'type': 'profile', 'name': 'scheme_member_ids', 'data':current_user_data_scheme_membership_ids, 'status': 'published'});
                        if(!returned)
                        {
                          console.error(`dsb-reader::hook__on_complete - record scheme_member_ids error`,returned);
                          throw `Sorry, an error seems to have occured.<br/>Please try again later.`
                        }
                        else
                        {
                          window.location.reload(true);
                        }
                        break;
                    defalut:
                        break;
                  }
                }

              }
              catch(ex)
              {
                console.error(ex);
              }
              await _this.dsbClient.user.resetCache();
              nav_task_panel.openByTaskNo(overview_task);
            });

            quiz.addHook('on_success',function(controller){
              nav_task_panel.setDone(controller.getAttribute('data-caller_id'));
            });

            quiz.addHook('on_fail',function(controller){
              nav_task_panel.setDone(controller.getAttribute('data-caller_id'),false);
            });

            for(let ii = 0; ii < item.questions.length; ii++)
            {
              quiz.setQuestion(item.uid, item.questions[ii].uid, item.questions[ii].question, (('options' in item.questions[ii])?item.questions[ii].options:{}), item.questions[ii].type, (('value' in item.questions[ii])?item.questions[ii].value:''),(('pattern' in item.questions[ii])?item.questions[ii].pattern:''),(('pattern_message' in item.questions[ii])?item.questions[ii].pattern_message:''));
            }
            item.tabs.push({'name': 'Quiz', 'content': quiz});
          }
        }
      }

      for(var section in this.data.sections)
      {

        let task = {};
        task.name = this.data.sections[section].name;
        task.target = this.service;
        task.active = false;
        if('active' in this.data.sections[section])
        {
          task.active = this.data.sections[section].active;
        }

        task.done = false;

        if('done' in this.data.sections[section])
        {
          task.done = this.data.sections[section].done;
        }

        if('hidden' in this.data.sections[section])
        {
          task.hidden = this.data.sections[section].hidden;
        }

        if('modal_mode' in this.data.sections[section])
        {
          task.modal_mode = this.data.sections[section].modal_mode;
        }

        task.type = 'item';

        let path = ''+this.data.content.id;

        let post_id = '';

        if('target_id' in this.data.sections[section])
        {
          post_id = this.data.sections[section].target_id;
        }
        else if('type_id' in this.data.sections[section])
        {
          post_id = this.data.sections[section].type_id;
        }

        if('questions' in this.data.sections[section])
        {
          task.questions = this.data.sections[section].questions;
          task.type = 'quiz';
        }

        if('type' in this.data.sections[section])
        {
          task.type = this.data.sections[section].type;
        }

        if('uid' in this.data.sections[section])
        {
          task.uid = this.data.sections[section].uid;
        }

        if('body' in this.data.sections[section])
        {
          task.post_content = this.data.sections[section].body;
        }

        if('post_data' in this.data.sections[section])
        {
          task.post_data = this.data.sections[section].post_data;
        }

        if(post_id)
        {
          task.target_id = post_id;
        }
        else
        {
            continue;
        }


        if(Array.isArray(this.path))
        {
          if(this.path.indexOf(task.target_id)>-1)
          {
            task.active = true;
          }
        }

        await set_tabs(task, path);

        if(`parts` in this.data.sections[section])
        {
          let overview_task = {};
          overview_task.name = 'Overview';
          overview_task.target = task.target;
          overview_task.uid = `overview`;
          overview_task.type = 'overview';
          overview_task.active = task.active;
          overview_task.target_id = task.target_id;
          if('post_content' in task)
          {
            overview_task.post_data = {};
            overview_task.post_data.title = 'Overview';
            overview_task.post_data.body = task.post_content;
            overview_task.post_data.document = {};
            overview_task.post_data.document.content = {};
            overview_task.post_data.document.content.rendered = task.post_content;
            overview_task.questions = [];
            for(var scheme_id in current_schemes)
            {
              overview_task.questions.push({
                'uid' :'scheme_'+scheme_id,
                'question':current_schemes[scheme_id].title,
                'pattern':current_schemes[scheme_id].pattern,
                'pattern_message':current_schemes[scheme_id].pattern_message,
                'type': 'text'
              });
            }
          }
          task.parts = this.data.sections[section].parts;
          task.parts.unshift(overview_task);
          for(let i = 0; i < task.parts.length; i++)
          {
            task.parts[i].active = false;
            task.parts[i].done = false;
            if(Array.isArray(this.path))
            {
              if(this.path.indexOf(task.parts[i].uid)>0)
              {
                task.parts[i].active = true;
              }
            }
            await set_tabs(task.parts[i], path);
          }
        }

        nav_task_panel.addTask(task);
      }

      nav_panel.append(nav_task_panel);


      // Clean
      this.innerHTML = ``;

      this.append(collection_card);
      this.append(nav_panel);
      this.append(workspaces_panel);
      nav_task_panel.refreshActive();

      return;
    }
    catch(ex)
    {
      console.error('dsb-reader:: Error',ex);
      this.classList.add('error');
      this.innerHTML = `
          <div style="overflow-x: auto;min-height:200px;margin-top:30px;">
                <article class="error-500" role="article">
                  <p>Sorry an error has occured.</p>
                  <p>Please try again by <a href="javascript:return;" onclick="window.location.reload(true);">clicking here</a> or try again later.</p>
                </article>
            </div>`;
      return;
    }
  }
}


